import { render, staticRenderFns } from "./STableFeeTypeComp.vue?vue&type=template&id=76bc449c&"
import script from "./STableFeeTypeComp.vue?vue&type=script&lang=js&"
export * from "./STableFeeTypeComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports